<template lang="html">
  <div id="results-page-s1">

    <section class="placed-backg banner-section companies">
      <div class="inside">
        <h1>Empresas contratando</h1>
      </div>
    </section>

    <!--section class="container search-form-section">
      <div class="content">
        <search-form-component></search-form-component>
      </div>
    </section-->

    <section class="container results-section">
      <div class="row">

        <!-- Columna izquierda con filtros -->
        <div class="col-lg-3 col-filters">
          <div class="bg-filters-mob" v-bind:class="{ active : isFiltersActive }" @click="isFiltersActive = false;"></div>

          <div class="filters-container" v-bind:class="{ active : isFiltersActive }">
            <div class="box-column-title">Personalizar búsqueda <a class="btn-close" @click="isFiltersActive = false;"><i class="fas fa-chevron-left"></i></a></div>

            <div class="main-box">

              <div class="box-filters-group">
                <h5 class="group-title">Busqueda</h5>

                <div class="box-options">
                  <b-form-group>
                    <b-form-input
                      v-model="searchForm.keywords"
                      type="text"
                      placeholder="Puesto o palabras clave"
                      required
                    ></b-form-input>
                  </b-form-group>

                  <div class="box-btn">
                    <b-button type="submit" class="btn-squ-1 lg">buscar</b-button>
                  </div>
                </div>
              </div>

              <div class="box-filters-group">
                <h5 class="group-title">Ubicación</h5>

                <div class="box-options">
                  <b-form-group label="Estado:" label-for="i-estado">
                    <b-form-select id="i-estado" v-model="searchForm.state" v-bind:class="{ empty : !searchForm.state }">
                      <b-form-select-option :value="null">Seleccionar Estado</b-form-select-option>
                      <b-form-select-option :value="state.id" v-for="state in statesOpcs" :key="state.id">{{state.name}}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>

                  <b-form-group label="Ciudad:" label-for="i-ciudad">
                    <b-form-select id="i-ciudad" v-model="searchForm.town" v-bind:class="{ empty : !searchForm.town }">
                      <b-form-select-option :value="null">Seleccionar Ciudad</b-form-select-option>
                      <b-form-select-option :value="town.id" v-for="town in townsOpcs" :key="town.id">{{town.name}}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>

                  <!-- <div class="box-btn">
                    <b-button type="submit" class="btn-squ-1 lg">buscar</b-button>
                  </div> -->
                </div>
              </div>

              <div class="box-filters-group">
                <h5 class="group-title">Sector</h5>

                <div class="box-options">
                  <b-form-group label-for="i-sector">
                    <b-form-select id="i-sector" v-model="searchForm.category" v-bind:class="{ empty : !searchForm.category }">
                      <b-form-select-option :value="null">Seleccionar Área</b-form-select-option>
                      <b-form-select-option :value="category.id" v-for="category in categoriesOpcs" :key="category.id">{{category.nombre}}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <div class="box-filters-group">
                <h5 class="group-title">Vacantes Publicadas</h5>

                <div class="box-options">
                  <b-form-group v-slot="{ ariaPub }">
                    <b-form-checkbox-group class="checkbox-radio-group">
                      <b-form-radio v-model="searchForm.publicado" :aria-describedby="ariaPub" name="publicado" value="0">Hace 1 hora</b-form-radio>
                      <b-form-radio v-model="searchForm.publicado" :aria-describedby="ariaPub" name="publicado" value="1">Últimas 24 horas</b-form-radio>
                      <b-form-radio v-model="searchForm.publicado" :aria-describedby="ariaPub" name="publicado" value="2">Últimos 7 días</b-form-radio>
                      <b-form-radio v-model="searchForm.publicado" :aria-describedby="ariaPub" name="publicado" value="3">Últimos 14 días</b-form-radio>
                      <b-form-radio v-model="searchForm.publicado" :aria-describedby="ariaPub" name="publicado" value="4">Último mes</b-form-radio>
                      <b-form-radio v-model="searchForm.publicado" :aria-describedby="ariaPub" name="publicado" value="5">Más de un mes</b-form-radio>
                    </b-form-checkbox-group>
                  </b-form-group>
                </div>
              </div>

              <div class="box-company" v-if="companyelite != null">
                <div class="box-title">
                  Empresa Elite
                </div>

                <div class="box">
                  <div class="col col-jobs">
                    <h5>{{companyelite.vacantes_total}} Vacantes</h5>

                    <ul>
                      <li v-for="category in companyelite.categories" :key="category.id">{{category.nombre}}</li>
                     
                    </ul>

                    <router-link class="trans-250 link-profile" :to="'/empresas/'+$root._converToURL(companyelite.nombre,companyelite.id)">VER PERFIL</router-link>
                  </div>

                  <div class="col col-logo">
                    <img :src="companyelite.imagen">
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <!--  -->

        <!-- Columna derecha con resultados de empleos -->
        <div class="col-lg-9 col-results">
          <div class="row top-container">
            <div class="col-12 d-lg-none col-mobile-filter">
              <a class="btn-cur-1" @click="isFiltersActive = !isFiltersActive"><i class="fas fa-filter"></i> <span v-if="!isFiltersActive">Mostrar</span> <span v-if="isFiltersActive">Ocultar</span> filtros avanzados</a>
            </div>

            <div class="col-lg-6 col-count">
              <h4>{{pagination.total}} Empresas encontradas</h4>
              <p>Mostrados  {{pagination.from}} -  {{pagination.to}} en esta página</p>
            </div>

            <div class="col-lg-6 col-options">
              <div class="box">
                <span>ordenar por</span>
                <b-form-select v-model="searchForm.order">
                  <b-form-select-option value="0">más recientes</b-form-select-option>
                  <b-form-select-option value="1">alfabeto</b-form-select-option>
                </b-form-select>
              </div>

              <div class="box">
                <span>resultados</span>
                <b-form-select v-model="searchForm.perPage">
                  <b-form-select-option value="10">10 por página</b-form-select-option>
                  <b-form-select-option value="20">20 por página</b-form-select-option>
                </b-form-select>
              </div>
            </div>
          </div>

          <div class="row results-container">
            <div class="col-12 col-jobs-elite" v-if="companyelite != null">
              <router-link class="box" :to="'/empresas/'+$root._converToURL(companyelite.nombre,companyelite.id)">
                <div class="col-12 col-title">
                  <h5>Empresa Elite</h5>
                </div>

                <div class="col-sm-4 col-info">
                  <h6>Empresa con gran interés de nuestros usuarios.</h6>
                </div>

                <div class="col-sm-4 col-logo">
                  <img :src="companyelite.imagen">
                </div>

                <div class="col-sm-4 col-info">
                  <h6>{{companyelite.vacantes_total}} Vacantes</h6>
                </div>
              </router-link>
            </div>

            <div class="col-12 col-jobs-s2" v-for="(company, hjbInx) in companies" :key="'hjbInx-'+hjbInx">
              <div class="box" >
                <!--div class="box-urgent"><span>URGENTE</span></div-->

                <div class="col col-logo" @click="$router.push('/empresas/'+$root._converToURL(company.nombre,company.id))" style="cursor: pointer;">
                  <img :src="company.imagen">
                </div>

                <div class="col col-info" @click="$router.push('/empresas/'+company.id)" style="cursor: pointer;">
                  <h4 class="title" style="font-family:sans-serif !important">{{ company.nombre }}</h4>
                  <h5><!--span class="company">{{ company.company }}</span--> <i class="loc-icon"></i><span class="location">{{ company.ciudad }}, {{ company.estado }}.</span></h5>
                  <h5 class="extra"><span class="score" style="
                  color: #fdc234">{{company.calification_general}} <i class="fas fa-star"></i></span></h5>
                </div>

                <div class="col-12 col-line">
                  <hr />
                </div>


                <div class="col col-buttons" @click="$router.push('/empresas/'+$root._converToURL(company.nombre,company.id))">
                  <a class="trans-250 btn-squ-1">Ver perfil</a>
                </div>

                <div class="col col-vacancies" @click="$router.push('/empresas/empleos/'+company.id)" style="cursor: pointer;">
                  <div class="best-companies" v-if="company.best"><span><i class="star"></i><i class="fas fa-star"></i> Mejores Empresas</span></div>
                  <h6>{{company.vacantes_total}} Vacantes</h6>
                </div>
              </div>
            </div>
          </div>

          <div class="row pagination-container">
            <div class="col-12 col-pagination">
              <b-pagination
                v-model="pagination.current_page"
                :total-rows="pagination.total"
                :per-page="pagination.per_page"
                aria-controls="my-table"
              ></b-pagination>
            </div>
          </div>
        </div>
        <!--  -->
      </div>
    </section>

  </div>
</template>

<script>
import searchFormComponent from '../shared/search-form-component.vue';
export default {
  data(){
    return{
      isFiltersActive: false,

      

      /*jobs: [
        { img: 'public/images/pages/jobs/logo-1.png', best: false, title: 'Ejecutivo de Cuenta', company: 'Insumos Quirúrgicos', type: 'Tiempo completo', typeColor: '#0e447b' },
        { img: 'public/images/pages/jobs/logo-2.png', best: false, title: 'Agente Inmobiliario', company: 'Blue Capital', type: 'Freelance', typeColor: '#d8248e' },
        { img: 'public/images/pages/jobs/logo-3.png', best: true, title: 'Distribuidor', company: 'Café Colibrí Artesanal', type: 'Tiempo completo', typeColor: '#0e447b' },
        { img: 'public/images/pages/jobs/logo-1.png', best: false, title: 'Recepcionista', company: 'Insumos Quirúrgicos', type: 'Tiempo completo', typeColor: '#0e447b' },
        { img: 'public/images/pages/jobs/logo-4.png', best: true, title: 'Estilista Canino', company: 'Happy Friends, Estética', type: 'Temporal', typeColor: '#ba0f48' },
        { img: 'public/images/pages/jobs/logo-5.png', best: false, title: 'Recepcionista', company: 'Inntralasik', type: 'Medio tiempo', typeColor: '#f1630d' },
        { img: 'public/images/pages/jobs/logo-6.png', best: true, title: 'Arquitecto', company: 'Promso Constructora', type: 'Tiempo completo', typeColor: '#0e447b' },
        { img: 'public/images/pages/jobs/logo-7.png', best: false, title: 'Vendedor de Mostrador', company: 'Ganesh, Té de Cacao', type: 'Tiempo completo', typeColor: '#0e447b' },
      ],*/
      companies:[],
      companyelite:{
        id:null,
        imagen:null,
        vacantes_total:null
      },
      searchForm: {
        keywords: null,
        category: null,
        state: null,
        town:null,

      },
      pagination:{
        current_page:1,
        order:0,
        per_page:10,
        total:0,
        from:1,
        to:10
      },
      statesOpcs:[],
      townsOpcs:[],
      categoriesOpcs:[]
    }
  },

  computed: {
    rows() {
      return this.companies.length
    }
   
  },
   watch:{
      'searchForm.state':function(val){
          this.getTownsOpcs(val);
      },      
      searchForm: {
        handler: function(val, oldVal) {
            this.searchCompanies();
        },
        deep: true
      },
      'pagination.per_page':function(){
          this.getCompanies();
      },
      'pagination.order':function(){
          this.getCompanies();
      },
      'pagination.current_page':function(){
          this.getCompanies();
      }
  },
  methods:{
      getCompanies(){
        axios.get(tools.url("/companiesFront/"+this.pagination.order+"/"+this.pagination.per_page+"/"+this.pagination.current_page)).then((response)=>{
            this.companies = response.data.companies.data;
            this.companyelite = response.data.elite;
            this.pagination.current_page = response.data.companies.current_page;
            this.pagination.per_page = response.data.companies.per_page;
            this.pagination.first_page = response.data.companies.first_page_url;
            this.pagination.last_page = response.data.companies.last_page;
            this.pagination.total = response.data.companies.total;
            this.pagination.from = response.data.companies.from;
            this.pagination.to = response.data.companies.to;
          }).catch((error)=>{

          });
      },
      searchCompanies(){
         axios.post(tools.url("/searchCompanies"),this.searchForm)
          .then((response)=>{
              this.companies = response.data;
          }).catch((error)=>{
              alert('Ocurrio un error en la busqueda');
          });
      },
      getStatesOpcs(){
        axios.get(tools.url("/states")).then((response)=>{
            this.statesOpcs = response.data;
          }).catch((error)=>{
          });
      },
      getTownsOpcs(state_id){
        axios.get(tools.url("/cities/"+state_id)).then((response)=>{
            this.townsOpcs = response.data;
          }).catch((error)=>{
          });
      },
      getCategories(){
          axios.get(tools.url("/categoriesFront"))
          .then((response)=>{
              this.categoriesOpcs = response.data;
          }).catch((error)=>{
            
          });
      },

  },
  mounted() {
      this.getStatesOpcs();
      this.getCategories();
      this.getCompanies();

  },

  components: {
    searchFormComponent
  },
}
</script>
